import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useForm,  } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormTextField from "../../components/textField/formTextField";
import LaddaButton from "../../components/buttons/laddaButton";
import FileUploadButton from "../../components/fileUploadBtn";
import { supplierType } from "../../constants/enums";

const CreateProductModal = ({
  open,
  handleClose,
  onSubmit,
  initialData = null,
  parentSelected = null,
  canManage = false
}) => {
  const urlApi = process.env.REACT_APP_API_URL;
  const isSupplierManagment = canManage;

  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");

  const handleFileChange = (file) => {
    setFile(file);
  };

const [isInternational, setIsInternational] = useState(false);
const schema = yup.object().shape({
  product_name: yup.string().required("Nombre requerido"),
  invima_register: yup.string().required("Registro requerido"),
  expire_date: yup.string().required("Fecha requerida"),
  importer_name: isInternational
      ? yup.string().required("Importador requerido")
      : yup.string().nullable(),
  health_register_holder: isInternational
      ? yup.string().required("Importador requerido")
      : yup.string().nullable()
});

useEffect(() => {
  if (parentSelected?.supplier_type === supplierType.international) {
    setIsInternational(true);
  } else {
    setIsInternational(false);
  }
}, [parentSelected]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset
  } = useForm({
  resolver: yupResolver(schema),
  context: { isInternational }, 
  mode: "onSubmit",
  defaultValues: {
    product_name: "",
    invima_register: "",
    expire_date: "",
    importer_name: "",
    health_register_holder: ""
  }
});

  useEffect(() => {
    if (!open) {
      reset({
        product_name: "",
        invima_register: "",
        expire_date: "",
        importer_name: "",
        health_register_holder: ""
      });
      setFile(null);
      setFileUrl("");
    }
  }, [open, reset]);

  useEffect(() => {
    if (initialData) {
      setValue("product_name", initialData.product_name || "");
      setValue("invima_register", initialData.invima_register || "");
      setValue("expire_date", initialData.expire_date || "");
      setValue("importer_name", initialData.importer_name || "");
      setValue("health_register_holder", initialData.health_register_holder || "");

      if (initialData.path) {
        setFileUrl(initialData.path);
      }
    }
  }, [initialData, setValue]);

  const submit = async (formData) => {
    const payload = new FormData();
    payload.append("supplier_id", parentSelected.id);
    payload.append("product_name", formData.product_name);
    payload.append("invima_register", formData.invima_register);
    payload.append("expire_date", formData.expire_date);
    payload.append("file", file ? file : null);
    payload.append("importer_name", formData.importer_name || "");
    payload.append("health_register_holder", formData.health_register_holder || "");
  
    if (initialData?.id) {
      payload.append("id", initialData.id);
    }

    onSubmit(payload);
    handleClose();
  };


  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="modal-title">
        <span className="gm-title">
          {initialData?.id
            ? "Editar Producto o Dispositivo"
            : "Crear Nuevo Producto o Dispositivo"}
        </span>
      </DialogTitle>
      <DialogContent style={{ paddingTop: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <p className="create-label ml-0">Producto o Dispositivo*</p>
            <FormTextField
              name="product_name"
              control={control}
              error={errors.product_name}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Registro Invima*</p>
            <FormTextField
              name="invima_register"
              control={control}
              error={errors.invima_register}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Fecha de Vencimiento*</p>
            <FormTextField
              name="expire_date"
              control={control}
              error={errors.expire_date}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid> 
          {isInternational && (
        <>
        <Grid item xs={12} md={6}>
        <p className="create-label ml-0">Nombre del Importador*:</p>
        <FormTextField
        name="importer_name"
        control={control}
        error={errors.importer_name}
        margin="0"
        disabled={!isSupplierManagment}
      />
      </Grid>

      <Grid item xs={12} md={6}>
      <p className="create-label ml-0">Titular del Registro Invima*:</p>
      <FormTextField
        name="health_register_holder"
        control={control}
        error={errors.health_register_holder}
        margin="0"
        disabled={!isSupplierManagment}
          />
       </Grid>
        </>
      )}
          <Grid item xs={12}>
            <p className="create-label ml-0">Anexo*</p>
            <FileUploadButton
              onFileChange={handleFileChange}
              path={fileUrl}
              buttonText="Subir archivo (PDF o imagen)"
              disabled={!isSupplierManagment}
            />
          </Grid>
        </Grid>

        <br />
        {isSupplierManagment && (
          <div className="HContainer j-center w-complete">
            <LaddaButton variant="contained" onClick={handleSubmit(submit)}>
              <p className="button_text">
                {initialData?.id ? "Editar" : "Crear"} Producto
              </p>
            </LaddaButton>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CreateProductModal;
